var OrderFormValue = /*@__PURE__*/ (function () {
    function OrderFormValue() {
        this.valid = true;
        this.errors = null;
        this.mand = 'Y';
    }
    OrderFormValue.prototype.setValue = function (value) {
        this.val = value;
        return this;
    };
    OrderFormValue.prototype.getValue = function () {
        return this.val;
    };
    OrderFormValue.prototype.setValid = function (valid) {
        this.valid = valid;
        return this;
    };
    OrderFormValue.prototype.getValid = function () {
        return this.valid;
    };
    OrderFormValue.prototype.setErrors = function (errors) {
        this.errors = errors;
        return this;
    };
    OrderFormValue.prototype.getErrors = function () {
        return this.errors;
    };
    OrderFormValue.prototype.setMin = function (min) {
        this.min = min;
        return this;
    };
    OrderFormValue.prototype.getMin = function () {
        return this.min;
    };
    OrderFormValue.prototype.setMax = function (max) {
        this.max = max;
        return this;
    };
    OrderFormValue.prototype.getMax = function () {
        return this.max;
    };
    OrderFormValue.prototype.setMand = function (mand) {
        this.mand = mand;
        return this;
    };
    OrderFormValue.prototype.getMand = function () {
        return this.mand;
    };
    OrderFormValue.prototype.setType = function (type) {
        this.type = type;
        return this;
    };
    OrderFormValue.prototype.getType = function () {
        return this.type;
    };
    OrderFormValue.prototype.setExpectedValue = function (expectedValue) {
        this.exceptedValue = expectedValue;
        return this;
    };
    OrderFormValue.prototype.getExpectedValue = function () {
        return this.exceptedValue;
    };
    return OrderFormValue;
}());
export { OrderFormValue };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.form-value.ts
// module id = null
// module chunks = 